import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => (
  <footer className="bg-black border-t border-white/10 py-12 px-6 md:px-12 text-center text-luxury-muted text-xs font-sans-luxury">
    <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
      <div className="flex items-center space-x-2 text-left">
        <span className="text-white font-serif-luxury tracking-widest font-bold">LUNAR LEGACIES</span>
        <span className="text-[10px] text-luxury-gold tracking-widest">• TRUSTED SINCE 1998</span>
      </div>
      <p>© 2026 Lunar Legacies. All rights reserved. Authenticity based on provenance, research, and documented history.</p>
      <div className="flex space-x-6">
        <Link to="/privacy" className="hover:text-luxury-gold cursor-pointer transition-colors duration-300" data-testid="footer-link-privacy">Privacy</Link>
        <Link to="/terms" className="hover:text-luxury-gold cursor-pointer transition-colors duration-300" data-testid="footer-link-terms">Terms</Link>
        <Link to="/provenance" className="hover:text-luxury-gold cursor-pointer transition-colors duration-300" data-testid="footer-link-provenance">Provenance</Link>
      </div>
    </div>
  </footer>
);
